module.exports = __webpack_public_path__ + "img/mevius-sky-blue.a9686da3.jpg";